var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 81,
    viewBox: "0 0 62 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M15.4329 64.7268H46.2989V61.5018H15.4329V64.7268ZM15.4329 46.2988H46.2989V43.0738H15.4329V46.2988ZM6.90988 80.1628C5.99455 80.1915 5.08303 80.0326 4.2314 79.6959C3.37978 79.3592 2.60607 78.8517 1.95788 78.2048C1.31096 77.5566 0.803515 76.7829 0.466786 75.9313C0.130056 75.0797 -0.0288367 74.1681 -0.000116067 73.2528V6.91282C-0.0288367 5.99749 0.130056 5.08596 0.466786 4.23434C0.803515 3.38271 1.31096 2.609 1.95788 1.96081C2.60607 1.31389 3.37978 0.806447 4.2314 0.469717C5.08303 0.132988 5.99455 -0.0259071 6.90988 0.00281359H43.0749L61.7329 18.6568V73.2488C61.7616 74.1641 61.6027 75.0757 61.266 75.9273C60.9293 76.7789 60.4218 77.5526 59.7749 78.2008C59.1269 78.8486 58.3532 79.3568 57.5014 79.6943C56.6496 80.0317 55.7377 80.1911 54.8219 80.1628H6.90988ZM41.4619 20.2728V3.22381H6.90988C6.4314 3.23359 5.95993 3.34079 5.52425 3.53885C5.08857 3.73692 4.69783 4.0217 4.37588 4.37581C4.02177 4.69776 3.73699 5.0885 3.53893 5.52418C3.34086 5.95985 3.23366 6.43133 3.22388 6.90981V73.2498C3.23366 73.7283 3.34086 74.1998 3.53893 74.6355C3.73699 75.0711 4.02177 75.4619 4.37588 75.7838C4.69783 76.1379 5.08857 76.4227 5.52425 76.6208C5.95993 76.8188 6.4314 76.926 6.90988 76.9358H54.8219C55.3004 76.926 55.7718 76.8188 56.2075 76.6208C56.6432 76.4227 57.0339 76.1379 57.3559 75.7838C57.71 75.4619 57.9948 75.0711 58.1928 74.6355C58.3909 74.1998 58.4981 73.7283 58.5079 73.2498V20.2698L41.4619 20.2728Z",
    fill: "url(#paint0_linear_1_2917)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2917",
    x1: -0.00341797,
    y1: 40.0828,
    x2: 61.7362,
    y2: 40.0828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52AE32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006535"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.37c5ac4d23d75afb4a19f41b01cbaf44.svg";
export { ForwardRef as ReactComponent };